import { createAPI } from '../../common'
// SourceConfig
export default {
  // 保存下载申请接口
  postDownloadApplySave: (config) => createAPI('customEncryptApiName-1/0nfejby.benjo0epxoMpbeBqqmz0tbwf', 'post', config),
  // 判断是否有待审申请接口
  getDownloadApplyCheckApply: (config) => createAPI('customEncryptApiName-1/0nfejby.benjo0epxoMpbeBqqmz0difdlBqqmz', 'get', config),
  // 通过驳回
  postDownloadApplyAudit: (config) => createAPI('customEncryptApiName-1/0nfejby.benjo0epxoMpbeBqqmz0bveju', 'post', config),
  // 获取配置,申请下载按钮
  getConfigs: (config) => createAPI('customEncryptApiName-1/0nfejby.benjo0dpogjh0hfuDpogjht', 'get', config)
}
